// Adapted from Contracto
import { IconButton, Icons, styled } from '@healthinal/ui';
import { ReactNode } from 'react';
import { theme } from '../../theme.ts';
import { DashedButton } from '../DashedButtonStyled.tsx';

export interface FileFormControlProps {
  value: File | null;
  onChange: (value: File | null) => void;
  placeholder?: ReactNode;
  accept?: string;
  disabled?: boolean;
}

export function FileInput({ value, onChange, placeholder, accept, disabled }: FileFormControlProps) {
  return (
    <DashedButton
      component="label"
      disabled={disabled}
      role={undefined}
      tabIndex={-1}
      endDecorator={
        value ? (
          <IconButton
            size="sm"
            disabled={disabled}
            sx={{ m: -1 }}
            onClick={(event) => {
              event.preventDefault();
              onChange(null);
            }}>
            <Icons.Close />
          </IconButton>
        ) : (
          <Icons.FileUploadOutlined />
        )
      }
      sx={{
        background: theme.vars.palette.background.surface,
        '&:hover': {
          background: theme.vars.palette.background.surface,
        },
        boxShadow: theme.vars.shadow.xs,
        width: '100%',
        justifyContent: 'space-between',
        typography: 'body-md',
        fontWeight: 'inherit',
        color: value ? theme.vars.palette.neutral.outlinedColor : theme.vars.palette.neutral.outlinedDisabledColor,
      }}>
      {value?.name ?? placeholder}
      <VisuallyHiddenInput
        type="file"
        value="" // overwrite value from field props as file inputs are always uncontrolled
        accept={accept}
        disabled={disabled}
        onChange={(event) => onChange(event.target.files?.[0] ?? null)}
      />
    </DashedButton>
  );
}

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
